/**
 * Remembers the last email address used to send a PO to a given vendor
 * (JCD-23) — a plain per-viewer localStorage convenience, not shared state,
 * so (unlike lib/storeFilter.ts) a simple get/set pair is enough; no
 * external-store/hook machinery needed.
 */
const KEY_PREFIX = 'pacebi-po-email:';

export function getLastPoEmailRecipient(supId: string): string {
  try {
    return localStorage.getItem(KEY_PREFIX + supId) ?? '';
  } catch {
    return ''; // storage blocked (private mode) — just start blank
  }
}

export function setLastPoEmailRecipient(supId: string, email: string): void {
  try {
    localStorage.setItem(KEY_PREFIX + supId, email);
  } catch {
    // best-effort persistence
  }
}
